import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Aitrcle from '@/components/Aitrcle'
import Details from '@/components/Details'
import Register from '@/components/register'
import login from '@/components/login'
import Jgjj from '@/components/jgjj'
import testimg from '@/components/testimg'
import user from '@/components/user'
import leaveWord from '@/components/leaveWord'


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
 return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode:'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/testimg',
      name: 'testimg',
      component: testimg
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Aitrcle',
      name: 'Aitrcle',
      component: Aitrcle
    },
    {
      path: '/jgjj',
      name: 'jgjj',
      component: Jgjj
    },
    {
      path: '/Aitrcle/Details',
      name: 'Details',
      component: Details
    },
    {
      path: '/leaveWord',
      name: 'leaveWord',
      component: leaveWord
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        hideHeader: true, //隐藏头: 真
        hideFooter:true
      },
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        hideHeader: true, //隐藏头: 真
        hideFooter:true
      },
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        hideHeader: true, //隐藏头: 真
        hideFooter:true
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js